import { useRef, useState, forwardRef, useImperativeHandle } from 'react'
import ReactQuill, { Quill } from 'react-quill'
//@ts-ignore
import * as Emoji from 'quill-emoji'
import { markdownToHtml, htmlToMarkdown } from './Parser'

import 'react-quill/dist/quill.snow.css'
import 'quill-emoji/dist/quill-emoji.css'

// Register the emoji module
Quill.register('modules/emoji', Emoji)

export interface EditorProps {
  value?: string
  onChange?: (changes: string) => void
}

// Define the editor ref type
export interface EditorRef {
  clearEditor: () => void
}

const TOOLBAR_OPTIONS = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'link'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['emoji'],
  ['clean'],
]

const modules = {
  toolbar: {
    container: TOOLBAR_OPTIONS,
  },
  clipboard: {
    matchVisual: false, // Ensures correct list behavior
  },
  'emoji-toolbar': true,
  'emoji-textarea': false,
  'emoji-shortname': true,
}

// Use forwardRef to expose methods
const Editor = forwardRef<EditorRef, EditorProps>((props, ref) => {
  const [value, setValue] = useState<string>(markdownToHtml(props.value || ''))
  const reactQuillRef = useRef<ReactQuill>(null)

  // Expose the clearEditor method to the parent component
  useImperativeHandle(ref, () => ({
    clearEditor: () => {
      setValue('')
    },
  }))

  const onChange = (content: string) => {
    setValue(content)
    if (props.onChange) {
      props.onChange(htmlToMarkdown(content))
    }
  }

  return (
    <ReactQuill
      ref={reactQuillRef}
      theme="snow"
      placeholder="Start writing..."
      modules={modules}
      value={value}
      onChange={onChange}
    />
  )
})

export default Editor
